import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "drawer-content note-form" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Choose note", -1)
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pencil" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Add", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

import { PropType, computed, onMounted, reactive } from "vue";
import { useStore } from "vuex";
import useVuelidate from "@vuelidate/core";
import { Actions, Mutations } from "@/store";
import { Note, noteValidations } from "@/models/note";
import { useLoading } from "../common/loading.composable";
import FieldChoice, { Item } from "../common/FieldChoice.vue";
import { DrawerActions } from "@/stores/drawer.store";
import { useEvents, Event } from "@/core/services/events.composable";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddNoteForm',
  props: {
  data: {
    type: Object as PropType<{ application: number; notes: Note[] }>
  }
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const events = useEvents();

const props = __props;

const noteOptions = computed<Item[]>(() =>
  (props.data?.notes || []).map((s) => {
    return {
      label: s.title,
      value: s
    };
  })
);

const choice = reactive({ value: null });

const note = reactive<Note>({
  ...store.state.note
});

const { loading, setLoading } = useLoading();

onMounted(() => {
  store.dispatch(Actions.GetApplications);

  store.dispatch(Actions.NewNote);
  const application_id =
    props.data?.application || store.state.note.application_id;
  Object.assign(note, { ...store.state.note, application_id });
});

const $v = useVuelidate(noteValidations, { note });
const emit = __emit;

const cancel = () => {
  emit("close");
};

const choose = () => {
  if (choice.value) {
    store.commit(Mutations.SetNote, choice.value);
    events.emit(Event.NoteCreated, choice.value);
    store.dispatch(DrawerActions.CloseDrawer);
    cancel();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (props.data?.notes?.length)
      ? (_openBlock(), _createElementBlock("form", _hoisted_2, [
          _hoisted_3,
          _createVNode(FieldChoice, {
            label: "Note",
            modelValue: choice.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((choice.value) = $event)),
            items: noteOptions.value
          }, null, 8, ["modelValue", "items"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "confirm",
              type: "button",
              disabled: _unref(loading),
              onClick: choose
            }, _hoisted_8, 8, _hoisted_5)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})